import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createActionWatchMiddleware from 'redux-action-watch/lib/middleware';
import rootReducer from './rootReducer';
import rootSagas from './rootSagas';

const sagaMiddleware = createSagaMiddleware();
const actionWatchMiddleware = createActionWatchMiddleware('watcher');
const middlewares = [actionWatchMiddleware, sagaMiddleware];

const composeEnhancers = (process.env.NODE_ENV !== 'production'
  && typeof window !== 'undefined'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
  || compose;

function configureStore() {
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(rootSagas);

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./rootReducer');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

const store = configureStore();

export default store;

export const getServiceTypesAvailableToTenant = () => {
  const selectedAuthenticatedUser = store.getState().user.authenticatedUsers.find(({ current }) => current);
  return selectedAuthenticatedUser.tenant.service_types;
};
export const serviceTypeIDMap = () => {
  const selectedAuthenticatedUser = store.getState().user.authenticatedUsers.find(({ current }) => current);
  return {
    HEP_ONLY: selectedAuthenticatedUser.tenant.service_types
      .find(({ slug }) => slug === 'HEP_ONLY')?.id,
    RTM: selectedAuthenticatedUser.tenant.service_types
      .find(({ slug }) => slug === 'RTM')?.id,
    SCREENING: selectedAuthenticatedUser.tenant.service_types
      .find(({ slug }) => slug === 'SCREENING')?.id,
  };
};
